import Swiper from 'swiper/bundle';

if ($(".slider-type-6.swiper-container").length > 0) {
    const slider_type_6_swiper = new Swiper(".slider-type-6.swiper-container", {
        slidesPerView: 'auto',
        loop: false,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        navigation: {
            nextEl: ".section-slider-type-6 .swiper-button-next.slider-type-6-swiper-button",
            prevEl: ".section-slider-type-6 .swiper-button-prev.slider-type-6-swiper-button",
        },
        pagination: {
            el: ".section-slider-type-6 .swiper-pagination",
            clickable: true,
        },

    });
}